import { DeleteVehicleMutationVariables } from "../../../generatedQueries";
import {
  Event,
  ConstructorArgs as EventConstructorArgs,
} from "../../core/Event";
import { EventCategories } from "../../event-categories";
import { EventSubCategories } from "../../event-sub-categories";

export type Data = {
  mutationVariables: DeleteVehicleMutationVariables;
};

export type ConstructorArgs = Data & Partial<EventConstructorArgs>;

class DeleteVehicleRequest extends Event<Data> {
  public constructor(args: ConstructorArgs) {
    const { mutationVariables, ...baseArgs } = args;

    super({
      ...baseArgs,
      category: EventCategories.UI,
      subCategory: EventSubCategories.VEHICLES,
      type: `DELETE_VEHICLE.REQUEST`,
      data: {
        mutationVariables,
      },
    });
  }
}

export { DeleteVehicleRequest };
